import { Tag } from '@loadsmart/miranda-react'

import type { StopAppointment } from 'core/appointments/domain/Appointment'

export type SchedulingStatusTagProps = {
  appointment?: StopAppointment
}

export function SchedulingStatusTag({ appointment }: SchedulingStatusTagProps) {
  if (appointment?.outOfTime) {
    return (
      <Tag variant="warning" size="small">
        Out of requested time
      </Tag>
    )
  }

  return null
}
